// Placeholder runners: six capsules driven by RaceSnapshots, and the shared camera the director
// moves (src/director). The world around them is the real environment (world/environment);
// the cats job replaces the capsules.
import { CapsuleGeometry, Group, Mesh, MeshStandardMaterial, PerspectiveCamera, type Scene } from 'three';
import { LANE_COUNT, laneCenterZ, posToX } from '../data/track';
import type { RaceSnapshot } from '../race/types';

// Lane accents from ui/index.md; data/cats.ts (cats job) becomes the real source.
const LANE_COLOURS = ['hsl(28,90%,60%)', 'hsl(195,90%,60%)', 'hsl(275,90%,60%)', 'hsl(52,90%,60%)', 'hsl(330,90%,60%)', 'hsl(120,90%,50%)'];

export class PlaceholderScene {
  readonly camera = new PerspectiveCamera(42, 16 / 9, 0.15, 6000);
  private runners: Mesh[] = [];

  /** `withRunners: false` keeps only the camera (the real cats come from world/cats). */
  constructor(readonly scene: Scene, withRunners = true) {
    if (!withRunners) return;
    const geo = new CapsuleGeometry(0.16, 0.42, 6, 16);
    geo.rotateZ(Math.PI / 2);
    const runners = new Group();
    runners.name = 'placeholder-runners';
    for (let lane = 0; lane < LANE_COUNT; lane++) {
      const m = new Mesh(geo, new MeshStandardMaterial({ color: LANE_COLOURS[lane], roughness: 0.45, metalness: 0.05 }));
      m.castShadow = true;
      m.name = `runner-${lane}`;
      m.position.set(0, 0.2, laneCenterZ(lane));
      this.runners.push(m);
      runners.add(m);
    }
    scene.add(runners);
  }

  setAspect(aspect: number): void {
    this.camera.aspect = aspect;
    this.camera.updateProjectionMatrix();
  }

  update(snap: RaceSnapshot, _dt: number, timeS: number): void {
    let lead = 0, last = Infinity;
    for (const c of snap.cats) {
      const x = posToX(c.displayPos);
      const m = this.runners[c.lane];
      if (m) {
        const bounce = c.speed > 0.5 ? Math.abs(Math.sin(timeS * 9 + c.lane)) * 0.08 : 0;
        m.position.set(x, 0.2 + bounce, laneCenterZ(c.lane));
      }
      lead = Math.max(lead, x);
      last = Math.min(last, x);
    }
  }
}
